import { Box } from "@mui/material";
import { useState, type ReactNode } from "react";

export type VideoMetadataThumbnailProps = {
  src: string;
  videoClassName?: string;
  placeholderClassName?: string;
  fallback?: ReactNode;
};

/**
 * First-frame preview via muted `<video>` + metadata seek (blob or `/rag/video/...` URLs).
 */
export function VideoMetadataThumbnail({
  src,
  videoClassName,
  placeholderClassName,
  fallback = null,
}: VideoMetadataThumbnailProps) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    if (fallback) return <>{fallback}</>;
    return placeholderClassName ? (
      <Box className={placeholderClassName} />
    ) : null;
  }

  return (
    <video
      className={videoClassName}
      src={src}
      muted
      playsInline
      preload="metadata"
      onLoadedMetadata={(e) => {
        const el = e.currentTarget;
        if (el.duration > 0.1) {
          el.currentTime = Math.min(0.5, el.duration * 0.05);
        }
      }}
      onError={() => setFailed(true)}
    />
  );
}
